import { useState } from "react";
import { useMutation } from "react-query";

import BaseButton from "../../../button/BaseButton";
import PrimaryButton from "../../../button/PrimaryButton";
import TextInput from "../../../form/TextInput";

import ErrorMessage from "../../../form/ErrorMessage";
import { saveUser } from "../../../../services/user";

interface IUserDetailsEditProps {
  user: any;
  onSaveClick: () => void;
  onCancelClick: () => void;
}

const UserDetailsEdit: React.FunctionComponent<IUserDetailsEditProps> = ({
  user,
  onSaveClick,
  onCancelClick,
}) => {
  const { mutateAsync: saveUserData, error } = useMutation<any, any>(
    (usertData) => saveUser(usertData)
  );
  const [currentUser, setCurrentUser] = useState(user);

  const handleInputChange = (field: string, value: any) => {
    setCurrentUser({
      ...currentUser,
      [field]: value,
    });
  };

  const handleSave = async (e: any) => {
    e.preventDefault();

    await saveUserData(currentUser);

    onSaveClick();
  };

  return (
    <form className="space-y-8" onSubmit={handleSave}>
      <div className="space-y-8 sm:space-y-5">
        <div className="space-y-6 sm:space-y-5">
          {error && (
            <ErrorMessage
              message="Save failed"
              details={[
                error?.response?.data?.errors?.[0]?.message ||
                  error?.response?.data?.message,
              ]}
            />
          )}

          <div className="space-y-3 sm:space-y-2">
            <div className="sm:grid sm:grid-cols-4 sm:gap-1 sm:items-start">
              <label
                htmlFor="name"
                className="block font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Name
              </label>
              <div className="sm:col-span-3">
                <TextInput
                  id="name"
                  value={currentUser.name}
                  onChange={(e) => handleInputChange("name", e.target.value)}
                />
              </div>
            </div>
            <div className="sm:grid sm:grid-cols-4 sm:gap-1 sm:items-start">
              <label
                htmlFor="email"
                className="block font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Email
              </label>
              <div className="sm:col-span-3">
                <TextInput
                  id="email"
                  type="email"
                  value={currentUser.email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                />
              </div>
            </div>
            <div className="sm:grid sm:grid-cols-4 sm:gap-1 sm:items-start">
              <label
                htmlFor="password"
                className="block font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Password
              </label>
              <div className="sm:col-span-3">
                <TextInput
                  id="password"
                  type="password"
                  value={currentUser.password}
                  onChange={(e) =>
                    handleInputChange("password", e.target.value)
                  }
                />
                <p className="text-gray-500 text-sm">
                  An empty field here will{" "}
                  <span className="font-bold">not</span> modify the current
                  password.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-2 justify-end">
        <BaseButton
          className="flex items-center px-3 py-2"
          type="button"
          onClick={onCancelClick}
        >
          <i className="fal fa-times mr-2" />
          Cancel
        </BaseButton>
        <PrimaryButton className="flex items-center  px-3 py-2" type="submit">
          <i className="fad fa-cloud-upload mr-2" />
          Save
        </PrimaryButton>
      </div>
    </form>
  );
};

export default UserDetailsEdit;
